import { RouteType } from "types/RouteType";

/**
 * Everee Onboarding Route
 * New worker payroll setup flow
 */
export const evereeOnboardingRoute: RouteType = {
  name: "Employee Onboarding",
  path: "/payroll/onboarding",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Payroll Setup",
      enableRefreshButton: false,
      enableBackButton: true,
      color: "primary",
      component: () => import("./Everee.Header"),
    },
    body: {
      component: () => import("./Everee.Onboarding.Body"),
      grayBackground: false,
    },
  },
  group: "Payroll",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async () => {
    // Allow navigation - onboarding check can be done in component
    return true;
  },
};

/**
 * Everee Home Route
 * Main payroll dashboard for workers
 */
export const evereeHomeRoute: RouteType = {
  name: "Payroll Home",
  path: "/payroll",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Payroll",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./Everee.Header"),
    },
    body: {
      component: () => import("./Everee.Home.Body"),
      grayBackground: false,
    },
  },
  group: "Payroll",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async () => {
    return true;
  },
};

/**
 * Everee Tax Documents Route
 * View and download tax documents (W2, 1099, etc.)
 */
export const evereeTaxDocumentsRoute: RouteType = {
  name: "Tax Documents",
  path: "/payroll/tax-documents",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Tax Documents",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./Everee.Header"),
    },
    body: {
      component: () => import("./Everee.TaxDocuments.Body"),
      grayBackground: false,
    },
  },
  group: "Payroll",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async () => {
    return true;
  },
};

/**
 * Everee Payment History Route
 * View past payments and pay stubs
 */
export const evereePaymentHistoryRoute: RouteType = {
  name: "Payment History",
  path: "/payroll/payment-history",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Payment History",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./Everee.Header"),
    },
    body: {
      component: () => import("./Everee.PaymentHistory.Body"),
      grayBackground: false,
    },
  },
  group: "Payroll",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async () => {
    return true;
  },
};

/**
 * Everee Payment Deposit Route
 * Manage bank account and deposit information
 */
export const evereePaymentDepositRoute: RouteType = {
  name: "Payment Deposit",
  path: "/payroll/deposit",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Deposit Settings",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./Everee.Header"),
    },
    body: {
      component: () => import("./Everee.PaymentDeposit.Body"),
      grayBackground: false,
    },
  },
  group: "Payroll",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async () => {
    return true;
  },
};

/**
 * Everee Home Address Route
 * Manage home address information
 */
export const evereeHomeAddressRoute: RouteType = {
  name: "Home Address",
  path: "/payroll/address",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Home Address",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./Everee.Header"),
    },
    body: {
      component: () => import("./Everee.HomeAddress.Body"),
      grayBackground: false,
    },
  },
  group: "Payroll",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async () => {
    return true;
  },
};

export default [
  evereeOnboardingRoute,
  evereeHomeRoute,
  evereeTaxDocumentsRoute,
  evereePaymentHistoryRoute,
  evereePaymentDepositRoute,
  evereeHomeAddressRoute,
];
